import React, { useState, useEffect, useContext } from "react";
import { Grid, Typography, Box, Button } from "@mui/material";
import { Select, MenuItem, FormControl, FormHelperText } from "@mui/material";
import "./ExitManagement.css";
import Context from "context/context";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import submitResignationAPIs from 'apis/panel/SubmitResignation/submitResignation';

import swal from 'sweetalert';


import {

    TextField

} from "@mui/material";
import reportsAPI from "../../../apis/panel/reports/reports.js";
import { Autocomplete } from "../../../../node_modules/@mui/material/index";
import moment from "../../../../node_modules/moment/moment";

const EMS_Involuntary_Resign = () => {

    const { state, dispatch } = useContext(Context);
    const [reasonForChange, setReasonForChange] = useState("");
    const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
    const [errorMessages, setErrorMessages] = useState({});
    const [exitReasons, setExitReasons] = useState([]);
    const [selectedReason, setSelectedReason] = useState("");
    const [employees, setEmployees] = useState([]);
    const [selectedLWD, setSelectedLWD] = useState(new Date());
    const [selectedResignDate, setSelectedResignDate] = useState(new Date());
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [uniqueEmployees, setUniqueEmployees] = useState([]);
    const [selectedAttrition, setSelectedAttrition] = useState("Involuntary");
    const [remarks, setRemarks] = useState("");

    const isEditable = false


    const { getInvoluntaryExitReasonsAPI, submitInvoluntaryResignationAPI, getAllActiveEmployees } = submitResignationAPIs()


    useEffect(() => {

        fetchExitReasons();
        fetchAllEmployees()

    }, [])

    const fetchExitReasons = async () => {
        try {


            const data = await getInvoluntaryExitReasonsAPI();


            if (data.status === "Ok" && Array.isArray(data.reasons)) {
                setExitReasons(data.reasons); // Set reasons in state
            } else {
                console.error("Invalid API response:", data);
            }
        } catch (error) {
            console.error("Error fetching exit reasons:", error);
        }
    };

    const fetchAllEmployees = async () => {
        const res = await getAllActiveEmployees();
        setEmployees(res?.data || []);

        let uniqueEmployees = res?.data?.filter(
            (employee, index, self) =>
                index ===
                self.findIndex(
                    (e) =>
                        e.employeeId === employee.employeeId &&
                        e.employeeCode === employee.employeeCode &&
                        e.firstName === employee.firstName &&
                        e.lastName === employee.lastName &&
                        e.departmentName === employee.departmentName
                )
        );

        setUniqueEmployees(uniqueEmployees || []);
    };


    const SubmitResignationForm = async () => {
        let errors = {};
        if (!selectedResignDate) {
            errors.selectedResignDate = true
        }
        if (!selectedEmployee) {
            errors.selectedEmployee = true
        }
        if (!selectedReason) {
            errors.selectedReason = true
        }
        if (!selectedLWD) {
            errors.selectedLWD = true
        }
        if (!remarks) {
            errors.remarks = true
        }


        setErrorMessages(errors)

        if (Object.keys(errors).length != 0) {

            toast.error("Please fill in the required fields.");
            return
        }

        const confirmation = await swal({
            title: "Confirm",
            text: "Are you sure you want to proceed with this termination?",
            icon: "warning",
            buttons: {
                cancel: {
                    text: "Reject",
                    value: false,
                    visible: true,
                    className: "swal-button-disagree",
                },
                confirm: {
                    text: "Accept",
                    value: true,
                    visible: true,
                    className: "swal-button-agree",
                },
            },
            dangerMode: false,
        });
        if (confirmation) {
            dispatch({ type: "SET_LOADING", payload: true });
            const body = {
                employeeId: selectedEmployee?.employeeId,
                lastWorkingDay: moment(selectedLWD, "DD/MM/YYYY").format("YYYY-MM-DD"),
                resignDate: moment(selectedResignDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                exitReason: selectedReason,
                attritionType: selectedAttrition,
                remarks: remarks
            }

            
            try {
                const data = await submitInvoluntaryResignationAPI(body);
                if (data.status === 'Ok') {
                    toast.success("Resignation submitted successfully");

                    setErrorMessages({})
                    fetchAllEmployees()
                    setSelectedResignDate(new Date());
                            setSelectedEmployee("")
                            setSelectedReason("")
                            setSelectedLWD(new Date());
                            setRemarks("")
                    dispatch({ type: "SET_LOADING", payload: false });
                } else {
                    toast.error("Error: " + data.message || "Unknown error");
                    dispatch({ type: "SET_LOADING", payload: false });
                }

            } catch (error) {
                toast.error("Error submitting resignation: " + error.message);

                dispatch({ type: "SET_LOADING", payload: false });
            }

        }
    };


    const handleResignDateChange = (date) => {
        setSelectedResignDate(date);
        setErrorMessages((prev) => ({
            ...prev,
            selectedResignDate: false,
        }));
    };

    const handleLWDChange = (date) => {
        setSelectedLWD(date);
        setErrorMessages((prev) => ({
            ...prev,
            selectedLWD: false,
        }));
    };

    const handleEmployeeChange = (event, newValue) => {

        setSelectedEmployee(newValue);
        setErrorMessages((prev) => ({
            ...prev,
            selectedEmployee: false,
        }));

    };

    const handleReasonChange = (event) => {
        setSelectedReason(event.target.value)

        setErrorMessages((prev) => ({
            ...prev,
            selectedReason: false,
        }));

    }




    return (
        <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
            <Box sx={{ width: '100%', typography: 'body1' }}>



                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />

                <Typography
                    variant="h5"
                    align="center"
                    className="self-title"
                >
                    Involuntary Resignation Form
                </Typography>

                <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>

                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Submission Date<span style={{ color: "red" }}>*</span></Box>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                sx={{ width: "100%" }}
                                id="resignationDate"
                                name="resignationDate"
                                value={selectedResignDate}
                                onChange={handleResignDateChange}
                                format="dd/MM/yyyy"
                                slotProps={{ field: { clearable: true } }}
                                renderInput={(params) => <TextField {...params} helperText={null} />}
                            />
                        </LocalizationProvider>
                        {errorMessages.selectedResignDate && (
                            <div className="error-message">This field is mandatory.</div>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Employee ID/Name<span style={{ color: "red" }}>*</span></Box>
                        <Autocomplete

                            options={
                                uniqueEmployees || []
                            }
                            getOptionLabel={(option) =>
                                option && Object.keys(option).length > 0
                                    ? option?.employeeCode +
                                    " - " +
                                    option?.firstName +
                                    " " +
                                    option?.lastName
                                    : ""
                            }
                            value={selectedEmployee}
                            onChange={handleEmployeeChange}
                            renderInput={(params) => <TextField {...params} />}
                        />
                        {errorMessages.selectedEmployee && (
                            <div className="error-message">This field is mandatory.</div>
                        )}
                    </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Department Name</Box>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Department Name"
                            value={selectedEmployee?.departmentName || ""}
                            InputProps={{
                                readOnly: true, // make it readonly so user can’t change
                            }}
                        />
                    </Grid>



                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Reason For Leaving<span style={{ color: "red" }}>*</span></Box>
                        <FormControl fullWidth>
                            <Select
                                labelId="reason-label"
                                id="reason"
                                placeholder="Select Reason"
                                value={selectedReason}
                                displayEmpty
                                onChange={handleReasonChange}
                                inputProps={{ "aria-label": "Without label" }}
                                style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                            >
                                <MenuItem value="">Select Reason</MenuItem>
                                {exitReasons.map((reason, index) => (
                                    <MenuItem key={index} value={reason}>
                                        {reason}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {errorMessages.selectedReason && (
                            <div className="error-message">This field is mandatory.</div>
                        )}
                    </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Last Working Date<span style={{ color: "red" }}>*</span></Box>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                sx={{ width: "100%" }}
                                id="lastWorkingDate"
                                name="lastWorkingDate"
                                value={selectedLWD}
                                onChange={handleLWDChange}
                                format="dd/MM/yyyy"
                                slotProps={{ field: { clearable: true } }}
                                renderInput={(params) => <TextField {...params} helperText={null} />}
                            />
                        </LocalizationProvider>
                        {errorMessages.selectedLWD && (
                            <div className="error-message">This field is mandatory.</div>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">
                            Attrition Type <span style={{ color: "red" }}>*</span>
                        </Box>
                        <FormControl fullWidth>
                            <Select
                                labelId="reason-label"
                                id="reason"
                                placeholder="Select Attrition"
                                value={selectedAttrition}
                                displayEmpty
                                onChange={(e) => setSelectedAttrition(e.target.value)}
                                inputProps={{ "aria-label": "Attrition Type" }}
                                style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                                disabled
                            >
                                <MenuItem value="Voluntary">Voluntary</MenuItem>
                                <MenuItem value="Involuntary">Involuntary</MenuItem>
                            </Select>
                        </FormControl>

                    </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Remarks<span style={{ color: "red" }}>*</span></Box>

                        <TextField
                            sx={{ border: "1px solid #B2D4F8" }}
                            id="justification"
                            name="justification"
                            placeholder="Enter remarks for termination"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value.trimStart())}
                            onBlur={(e) => setRemarks(e.target.value.trim())} />
                        {errorMessages.remarks && <FormHelperText>{errorMessages.remarks}</FormHelperText>}

                    </Grid>


                </Grid>


                <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >
                    <Grid item xs={12} sm={2} md={2} lg={2}>
                        <Button className="cancelButton" onClick={() => {
                            setSelectedResignDate(new Date());
                            setSelectedEmployee("")
                            setSelectedReason("")
                            setSelectedLWD(new Date());
                            setRemarks("")

                        }}>Cancel</Button>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} lg={2}>
                        <Button className="saveButton" onClick={() => SubmitResignationForm()}> Submit </Button>
                    </Grid>
                </Grid>



            </Box>
        </div>
    );
};

export default EMS_Involuntary_Resign;

